import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useSelectedShopId } from '../../../../hooks/useSelectedShop';
import { ClaimShopCarrier } from '../../claims/types';
import container from '../../../../container';

/**
 * Hook to fetch carriers available for claims for the selected shop
 * @returns {UseQueryResult<ClaimShopCarrier[]>} Query result with carriers data
 */
export function useClaimsShopCarriers(): UseQueryResult<ClaimShopCarrier[]> {
  const shopId = useSelectedShopId();

  return useQuery({
    queryKey: ['shopClaimsCarriers', shopId],
    queryFn: () => container.touchpointsApi.getClaimsShopCarriers(shopId),
  });
}
